// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const PASSWORD_RESET_WE_SENT_YOU_NEW_TOKEN_CALL = "Vol\u00e1me ti znova a nadiktujeme nov\u00fd overovac\u00ed k\u00f3d.";
export const PASSWORD_RESET_WE_SENT_YOU_NEW_TOKEN_SMS = "Poslali sme ti nov\u00fd overovac\u00ed k\u00f3d.";
export const PHONE_NUMBER_SAVED = "Telef\u00f3nne \u010d\u00edslo bolo ulo\u017een\u00e9.";
